export const LOAD_REQUESTED = "SELECT_WIDGET/LOAD_REQUESTED";
export const LOAD_SUCCESS = "SELECT_WIDGET/LOAD_SUCCESS";
export const LOAD_FAIL = "SELECT_WIDGET/LOAD_FAIL";

export default (state = {}, { type, data }) => {
    switch (type) {
    case LOAD_REQUESTED: {
        return state;
    }
    case LOAD_SUCCESS: {
        return state;
    }
    case LOAD_FAIL: {
        return state;
    }
    default: return state;
    }
};

export const requestLoadSelectWidget = data => ({ type: LOAD_REQUESTED, data });
export const successLoadSelectWidget = data => ({ type: LOAD_SUCCESS, data });
export const failLoadSelectWidget = data => ({ type: LOAD_FAIL, data });
